import React from 'react';
import { injectIntl } from 'react-intl';

import VideoEmbed from '../VideoEmbed';

import ActionButton from '../../builder/ActionButton';
import Autocomplete from '../../builder/Autocomplete';
import Input from '../../builder/Input';
import RadioGroup from '../../builder/RadioGroup';
import Rating from '../../builder/Rating';
import Select from '../../builder/Select';
import TextArea from '../../builder/TextArea';

const SelectedAnswer = ({ order, on_media, ...props }) => {
	let ticker_classname = ['gui_selection_ticker'];
	if(on_media) ticker_classname.push('on_media');

	return (
		<span class={ticker_classname.join(" ")}>
			<span>
				{(order != 0) && (
					<span class="original_color_item">{order}</span>
				)}

				{(order == undefined) && (
					<span class="is_tick ep-on original_color_item" />
				)}
			</span>
		</span>
	)
}

const Answer = (props) => {
	const answer = props.answer;
	const errors = props.errors;

	let values = [];
	if(answer.config != undefined && answer.config.values != undefined) {
		values = ((!Array.isArray(answer.config.values)) ? answer.config.values.split("\n") : answer.config.values).filter((v) => (v != "" && v.trim()!=""));
	}

	let rawoptions = values.map((v) => ({ k:v, v }));
	let options = rawoptions;

	if(answer.config != undefined && answer.config.first_empty != undefined && answer.config.first_empty) {
		options =  [{k:'-',v:' '}].concat(rawoptions);
	}

	const has_media = (answer.image || answer.video) ? true : false;
	const has_text  = (answer.config.type == 'closed_text' && answer.config.hidetext) ? false : true;
	const has_both  = (has_media && has_text) ? true : false;

	const is_single_columed = (answer.isVertical || !has_both) ? true : false;

	const is_full_bordered = props?.is_full_bordered ?? true;

	const has_click_event = (answer.config.type == 'closed_text') ? true : false;

	let selected_mark_position_on_media = false;
	if((has_media || has_both) && is_single_columed) selected_mark_position_on_media = true;
	if(props.force_selected_mark_position_on_media != undefined) selected_mark_position_on_media = props.force_selected_mark_position_on_media;

	const answer_label = (answer.answer != undefined && answer.config.hidetext) ? null : answer.answer;

	const fetchOptions = (v, cb) => {
		const config_values = (Array.isArray(answer.config.values)) ? answer.config.values:answer.config.values.split("\n");
		let vs = config_values.filter((o) => {
			var reg = new RegExp(v.value, 'gi');
			return reg.test(o);
		});

		cb(vs.map((v) => ({ value:v })));

		return vs;
	};

	const clicked = (e) => {
		if(props.onClick != undefined) props.onClick(e, answer);
	};

	const change = (k, v) => {
		if(props.onChange != undefined) props.onChange(answer, v);
	}

	let answer_classes_arr = ['single_answer', `type_${answer.config.type}`];
	answer_classes_arr.push((is_single_columed) ? 'single_columned' : 'double_columned');
	answer_classes_arr.push((has_both) ? 'has_both' : ((has_media) ? 'has_media' : 'has_text'));
	if(answer.selected) answer_classes_arr.push('selected');

	if(is_full_bordered && (has_media || answer.config.type == 'closed_text')) {
		if(has_text) {
			answer_classes_arr.push('fully_bordered');
		} else {
			answer_classes_arr.push('fully_bordered_only_media');
		}
	}

	const default_field_props = {
		autotranslate:false,
		_class:{
			first:true,
		},
	}

	return (
		<li id={`a_${answer.id}`} class={answer_classes_arr.join(" ")} onClick={(has_click_event) ? clicked : null}>
			<div class="answer_container">
				{(has_media) && (
					<div class="media_cont">
						{(answer.image && (answer.video == null || answer.video == "")) && (
							<img src={answer.fullimage} width="100%" alt="" />
						)}

						{(answer.video) && (
							<VideoEmbed
								video_url={answer.video.full_url}
								video_thumb={(answer.image) ? answer.fullimage : answer.video.image}
								_class={{button_size:'small'}}
							/>
						)}
					</div>
				)}

				{(has_media && answer.selected && selected_mark_position_on_media) && (
					<SelectedAnswer
						on_media={true}
						order={answer.order}
					/>
				)}

				{(answer.config.type == 'closed_text' && !answer.config.hidetext) && (
					<div class="text_cont">
						<ActionButton
							color={false}
							_class={{ other:'gui_answer_button' }}
							autotranslate={false}
						>
							<span dangerouslySetInnerHTML={{ __html:answer.answer}} />
						</ActionButton>
					</div>
				)}

				{(answer.config.type == 'open_text' && answer.config.text_size) && (
					<div class="text_cont">
						<TextArea
							name={answer.id}
							errors={errors}
							change={change}
							value={answer.value}
							max_length={(answer.config.max_length) ? answer.config.max_length : null}
							{...default_field_props}
						>{answer_label}</TextArea>
					</div>
				)}

				{(answer.config.type == 'open_text' && !answer.config.text_size) && (
					<div class="text_cont">
						<Input
							name={answer.id}
							errors={errors}
							change={change}
							value={answer.value}
							max_length={(answer.config.max_length) ? answer.config.max_length : null}
							autotranslate={false}
							_class={{first:true}}
						>{answer_label}</Input>
					</div>
				)}

				{(answer.config.type == 'list') && (answer.config.list_type == 'list' || answer.config.list_type == undefined) && (
					<div class="text_cont">
						<Select
							change={change}
							value={answer.value}
							name={answer.id}
							errors={errors}
							values={options}
							{...default_field_props}
						>{answer_label}</Select>
					</div>
				)}

				{(answer.config.type == 'list' && answer.config.list_type == 'autocomplete') && (
					<div class="text_cont">
						<Autocomplete
							name={answer.id}
							onChange={(v) => change('', v)}
							errors={errors}
							values={options}
							fetch={fetchOptions}
							selected={(v) => change('', v.suggestion.value)}
							{...default_field_props}
						>{answer_label}</Autocomplete>
					</div>
				)}

				{(answer.config.type == 'list' && answer.config.list_type == 'radios') && (
					<div class="text_cont">
						<RadioGroup
							name={answer.id}
							change={(k, v) => change('', v)}
							default={null}
							elements={rawoptions.map(e => ({label:e.v, value:e.k}))}
							{...default_field_props}
						>{answer_label}</RadioGroup>
					</div>
				)}

				{(answer.config.type == 'rating') && (
					<div class="text_cont">
						<Rating
							name="rating"
							change={change}
							value={answer.value}
							default_rate={answer.config.default_rate}
							star_count={answer.config.star_count}
							icon_off={((answer.config.img_off != undefined) ? answer.config.img_off.replace("raty_icon ", "") : 'knk-star-off')}
							icon_on={((answer.config.img_on != undefined) ? answer.config.img_on.replace("raty_icon ", "") : 'knk-star-on')}
							icon_reset='ep-delete-circle'
							{...default_field_props}
						>{answer_label}</Rating>
					</div>
				)}

				{(answer.selected && !selected_mark_position_on_media) && (
					<SelectedAnswer
						on_media={false}
						order={answer.order}
					/>
				)}
			</div>
		</li>
	)
}

export default injectIntl(Answer);